module.exports = "/_next/static/images/114349c7aa5c1eebd610b5fb7eb83cfc-purple-help-icon.svg";